import objectFitImages from 'object-fit-images';
const $ = window.jQuery;

$(() => {
    if ($('.vist-hero').length) {
        objectFitImages('.visit-hero__bg__img');
    }
});
